module.exports = __webpack_public_path__ + "static/media/banana-transparent.8c6aa934.png";